<template>
  <div id="table-header" v-fix-to-top="{ placeholder: 'table-header-placeholder', topbar: '#topbar', xScroll: '#table-wrapper' }"
       class="notextselect"
       @mouseover="$store.state.ui.planning.hovertimeline = true" @mouseout="$store.state.ui.planning.hovertimeline = false"
       @contextmenu="showContextMenu">
    <div :style="{ 'margin-top': snapshot ? '8px' : '' }" :class="{ 'single-timeline': ! visibleTimeline.subtimelinecols.length }" class="timeline">
      <div v-for="(col, colIndex) in visibleTimeline.timelinecols" :style="{ width: col.width + 'px' }" :title="datesTitle(col)" class="col-header designcolor-main-bg">
        <span>{{ col.width >= 80 ? col.label : '&nbsp;' }}</span>
        <div v-if="canModifyPlanning" class="col-menu">
          <div v-if="! colIndex" :title="$t('PLANNING.ADD_NEW_COLUMN_BEFORE')" class="col-context-menu pull-left pointer" @click="addCol({ where: 'first', stepIndex: 0 })">
            <span class="fa fa-plus iconshadow"></span>
          </div>
          <div v-if="! colIndex" :title="$t('PLANNING.HIDE_COLUMN')" class="col-context-menu col-context-menu-hide pull-right pointer" @click="hideCol({ where: 'first', stepIndex: 0 })">
            <span class="fa fa-minus iconshadow"></span>
          </div>
          <div v-if="colIndex == visibleTimeline.timelinecols.length - 1"
               :title="$t('PLANNING.ADD_NEW_COLUMN_AFTER')" class="col-context-menu pull-right pointer"
               @click="addCol({ where: 'last', stepIndex: 0 })">
            <span class="fa fa-plus iconshadow"></span>
          </div>
          <div v-if="colIndex == visibleTimeline.timelinecols.length - 1"
               :title="$t('PLANNING.HIDE_COLUMN')" class="col-context-menu col-context-menu-hide pull-left pointer"
               @click="hideCol({ where: 'last', stepIndex: 0 })">
            <span class="fa fa-minus iconshadow"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="visibleTimeline.subtimelinecols.length" class="timeline-divider"></div>
    <div class="subtimeline">
      <div v-for="(subcol, subColIndex) in visibleTimeline.subtimelinecols" :style="{ width: subcol.width + 'px' }" :title="datesTitle(subcol)" class="col-header designcolor-second-bg">
        <span>{{ (! subcol.colspan || subcol.colspan > .6) ? subcol.label : '&nbsp;' }}</span>
        <div v-if="canModifyPlanning" class="col-menu">
          <div v-if="! subColIndex" :title="$t('PLANNING.ADD_NEW_COLUMN_BEFORE')" class="col-context-menu pull-left pointer" @click="addCol({ where: 'first', stepIndex: 1 })">
            <span class="fa fa-plus iconshadow"></span>
          </div>
          <div v-if="! subColIndex" :title="$t('PLANNING.HIDE_COLUMN')" class="col-context-menu col-context-menu-hide pull-right pointer" @click="hideCol({ where: 'first', stepIndex: 1 })">
            <span class="fa fa-minus iconshadow"></span>
          </div>
          <div v-if="subColIndex == visibleTimeline.subtimelinecols.length - 1"
               :title="$t('PLANNING.ADD_NEW_COLUMN_AFTER')" class="col-context-menu pull-right pointer"
               @click="addCol({ where: 'last', stepIndex: 1 })">
            <span class="fa fa-plus iconshadow"></span>
          </div>
          <div v-if="subColIndex == visibleTimeline.subtimelinecols.length - 1"
               :title="$t('PLANNING.HIDE_COLUMN')" class="col-context-menu col-context-menu-hide pull-left pointer"
               @click="hideCol({ where: 'last', stepIndex: 1 })">
            <span class="fa fa-minus iconshadow"></span>
          </div>
        </div>
      </div>
    </div>
    <planning-timeline-scrollbar v-if="! snapshot" :visible-timeline="visibleTimeline"></planning-timeline-scrollbar>
    <div v-if="showPresentTime" :style="{ left: visibleTimeline.presenttimeWidth + 'px' }" :title="$t('GLOBAL.TODAY')" class="presenttime">
      <i class="fa fa-caret-down"></i>
    </div>
    <planning-timeline-context-menu v-model="contextMenu.show" :timeline="planning.timeline" :can-open-config="canModifyPlanning || dashboard"
                                    :position-x="contextMenu.x" :position-y="contextMenu.y">
    </planning-timeline-context-menu>
  </div>
</template>

<style>
  #table-header {
    background: white;
    padding-top: 5px;
    text-align: center;
    position: relative;
    cursor: grab;
  }

  #table-header.fixed {
    position: fixed;
    top: 0px;
    z-index: 300;
    width: inherit;
    box-shadow: 0px 1px 10px grey;
    transform: translateZ(0);
  }
</style>

<script>
  import { mapActions } from 'vuex';
  import drag2scrolltimelineMixin from './PlanningTimeline/drag2scrolltimeline';
  import PlanningTimelineScrollbar from './PlanningTimeline/PlanningTimelineScrollbar';
  import PlanningTimelineContextMenu from './PlanningTimeline/PlanningTimelineContextMenu';

  export default {
    components: {
      PlanningTimelineScrollbar,
      PlanningTimelineContextMenu,
    },
    mixins: [drag2scrolltimelineMixin],
    props: {
      planning: { type: Object, required: true },
      dynamic: { type: Boolean, default: false },
      view: { type: Boolean, default: false },
      dashboard: { type: Boolean, default: false },
    },
    data() {
      return {
        contextMenu: { show: false, x: 0, y: 0 },
      };
    },
    computed: {
      visibleTimeline() {
        return this.planning.visibleTimeline;
      },
      showPresentTime() {
        return this.visibleTimeline.show_presenttime && this.visibleTimeline.presenttimeWidth > 0 && this.visibleTimeline.presenttimeWidth <= this.visibleTimeline.pxwidth;
      },
      snapshot() {
        return this.$store.state.ui.planning.snapshot;
      },
      canModifyPlanning() {
        return this.dynamic && ! this.view;
      },
    },
    watch: {
      'contextMenu.show': function (newVal) {
        if (newVal) {
          window.addEventListener('scroll', this.hideContextMenu);
        } else {
          window.removeEventListener('scroll', this.hideContextMenu);
        }
      },
    },
    methods: {
      datesTitle(col) {
        return `${this.$filters.moment(col.starttime, 'mediumDateNoYear', true)} - ${this.$filters.moment(col.endtime, 'mediumDateNoYear', true)}`;
      },
      showContextMenu(e) {
        if (e.shiftKey) return; // shift to shorcut the menu
        e.preventDefault();
        _.extend(this.contextMenu, {
          show: false,
          x: e.clientX,
          y: document.querySelector('#table-header').getBoundingClientRect().y + 7,
        });
        this.$nextTick(() => {
          this.contextMenu.show = true;
        });
      },
      hideContextMenu() {
        this.contextMenu.show = false;
      },
      ...mapActions('planning/timeline', ['addCol', 'hideCol']),
    },
  };
</script>
